import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getSelection, $setSelectionRange } from "lexical";
/*import {
  FORMAT_TEXT_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  INSERT_ORDERED_LIST_COMMAND
} from "lexical";*/
import { FORMAT_TEXT_COMMAND } from "lexical";
import {
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  REMOVE_LIST_COMMAND
} from "@lexical/list";
import { $setBlocksType } from "@lexical/selection";
import { $createHeadingNode } from "@lexical/rich-text";
import { $createImageNode } from "../components/ImageNode";
import { INSERT_IMAGE_COMMAND } from "../components/ImageNode";

// ICON IMPORTS
import BoldIcon from "../components/BlogEditorIcons/type-bold.svg";
import ItalicIcon from "../components/BlogEditorIcons/type-italic.svg";
import UnderlineIcon from "../components/BlogEditorIcons/type-underline.svg";
import BulletIcon from "../components/BlogEditorIcons/list-ul.svg";
import NumberIcon from "../components/BlogEditorIcons/list-ol.svg";
import ImageIcon from "../components/BlogEditorIcons/file-image.svg";
import H2 from "../components/BlogEditorIcons/type-h2.svg";
import H1 from "../components/BlogEditorIcons/type-h1.svg";
import H3 from "../components/BlogEditorIcons/type-h3.svg";

import FontFamilyPlugin from "../components/FontFamilyPlugin";


export default function ToolbarPlugin() {
  const [editor] = useLexicalComposerContext();

  return (
    <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
      <FontFamilyPlugin />

      <button onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold")}><img src={BoldIcon} alt="Bold" style={{ width: 20 }} /></button>
      <button onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic")}><img src={ItalicIcon} alt="Italic" style={{ width: 20 }} /></button>
      <button onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline")}><img src={UnderlineIcon} alt="Underline" style={{ width: 20 }} /></button>

    <button
        onClick={() => {
          editor.update(() => {
            const selection = $getSelection();
            if (selection) {
              $setBlocksType(selection, () => $createHeadingNode("h1"));
            }
          });
        }}
      >
        <img src={H1} alt="H1" style={{ width: 20 }} />
      </button>

      <button
        onClick={() => {
          editor.update(() => {
            const selection = $getSelection();
            if (selection) {
              $setBlocksType(selection, () => $createHeadingNode("h2"));
            }
          });
        }}
      >
        <img src={H2} alt="H2" style={{ width: 20 }} />
      </button>

      <button
        onClick={() => {
          editor.update(() => {
            const selection = $getSelection();
            if (selection) {
              $setBlocksType(selection, () => $createHeadingNode("h3"));
            }
          });
        }}
      >
        <img src={H3} alt="H3" style={{ width: 20 }} />
      </button>

      <button onClick={() => editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND)}>
        <img src={BulletIcon} alt="Bulleted list" style={{ width: 20 }} />
      </button>
      <button onClick={() => editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND)}>
        <img src={NumberIcon} alt="Numbered list" style={{ width: 20 }} />
      </button>

      <button
        onClick={() => {
          const input = document.createElement("input");
          input.type = "file";
          input.accept = "image/*";
          input.onchange = async (e) => {
            const file = e.target.files[0];

            const form = new FormData();
            form.append("image", file);

            const res = await fetch("/blogUpload/image", {
              method: "POST",
              body: form
            });

            const { url } = await res.json();

            editor.dispatchCommand(INSERT_IMAGE_COMMAND, { src: url });
          };
          input.click();
        }}
      >
        <img src={ImageIcon} alt="Add Image" style={{ width: 20 }} />
      </button>
    </div>
  );
}
